<template>
  <div class="relative flex space-x-3">
    <div>
      <span class="h-8 w-8 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white">
        <!-- Heroicon name: user -->
        <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
        </svg>
      </span>
    </div>
    <div class="min-w-0 flex-1 flex justify-between space-x-4">
      <div>
        <h3 class="text-sm font-medium">{{title}}</h3>
        <p class="text-sm text-gray-500">{{subtitle}}</p>
      </div>
      <div class="text-right text-sm whitespace-nowrap text-gray-500">
        <time datetime="2020-09-20">{{formatDate(time)}}</time>
      </div>
    </div>
  </div>
</template>
<script>

import { format } from 'date-fns'
import { utclocaliso } from '@/utils/utils'
export default {
  name: 'flow-record-panel-item',
  props: {
    title: String,
    time: String,
    subtitle: String
  },
  methods: {
    formatDate(s) {
      return format(new Date(utclocaliso(s)), 'dd/MM/yy HH:mm:ss')
    }
  },
}

</script>
